import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import blogPosts, { blogCategories } from './data/blogPosts';
import './BlogPage.css';

const samplePosts = blogPosts;
const categories = blogCategories;

const BlogPage = () => {
    useEffect(() => {
        document.title = 'Blog | PhysioActivity';
        const meta = document.querySelector('meta[name="description"]');
        if (meta) meta.setAttribute('content', 'Insights, research, and updates from the world of musculoskeletal health.');
    }, []);

    const [activeCategory, setActiveCategory] = useState('All');

    const filteredPosts = activeCategory === 'All'
        ? samplePosts
        : samplePosts.filter(post => post.category === activeCategory);

    const featuredPost = filteredPosts.length > 0 ? filteredPosts[0] : null;
    const remainingPosts = filteredPosts.length > 1 ? filteredPosts.slice(1) : [];

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
    };

    const getInitials = (name) => {
        if (!name) return '?';
        return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
    };

    return (
        <div className="blog-page">
            {/* Hero on the site baseline. .pa2 is scoped to the hero: the listing
                below keeps its own card styles, and .pa2 a would strip the link
                colour off every card title. */}
            <div className="pa2">
                <section className="hero" id="top">
                    <div className="wrap">
                        <h1 className="on-dark">
                            <span className="setup">Research, practice,</span>
                            <span className="payoff">and what we are learning.</span>
                        </h1>
                        <p className="lede">
                            Perspectives on musculoskeletal health, digital physiotherapy, and the
                            evidence underneath both.
                        </p>
                    </div>
                </section>
            </div>

            <div className="blog-container">
                {/* Category Filter Bar */}
                <div className="blog-filter-bar">
                    {categories.map((category) => (
                        <button
                            key={category}
                            className={`blog-filter-btn ${activeCategory === category ? 'active' : ''}`}
                            onClick={() => setActiveCategory(category)}
                        >
                            {category}
                        </button>
                    ))}
                </div>

                {/* Featured Post */}
                {featuredPost && (
                    <Link to={`/blog/${featuredPost.slug}`} className="blog-featured-card">
                        <div className="blog-featured-image">
                            <span className="blog-category-tag">{featuredPost.category}</span>
                        </div>
                        <div className="blog-featured-content">
                            <h2 className="blog-featured-title">{featuredPost.title}</h2>
                            <p className="blog-featured-excerpt">{featuredPost.excerpt}</p>
                            <div className="blog-card-meta">
                                <div className="blog-card-author">
                                    <div className="blog-author-avatar">
                                        {getInitials(featuredPost.author)}
                                    </div>
                                    <div className="blog-author-info">
                                        <span className="blog-author-name">{featuredPost.author}</span>
                                        <span className="blog-meta-details">
                                            {formatDate(featuredPost.date)} &middot; {featuredPost.readTime} read
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                )}

                {/* Post Grid */}
                {remainingPosts.length > 0 && (
                    <div className="blog-grid">
                        {remainingPosts.map((post) => (
                            <Link to={`/blog/${post.slug}`} key={post.slug} className="blog-card">
                                <div className="blog-card-image">
                                    <span className="blog-category-tag">{post.category}</span>
                                </div>
                                <div className="blog-card-body">
                                    <h3 className="blog-card-title">{post.title}</h3>
                                    <p className="blog-card-excerpt">{post.excerpt}</p>
                                    <div className="blog-card-meta">
                                        <div className="blog-card-author">
                                            <div className="blog-author-avatar small">
                                                {getInitials(post.author)}
                                            </div>
                                            <div className="blog-author-info">
                                                <span className="blog-author-name">{post.author}</span>
                                                <span className="blog-meta-details">
                                                    {formatDate(post.date)} &middot; {post.readTime} read
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}

                {/* Empty State */}
                {filteredPosts.length === 0 && (
                    <div className="blog-empty-state">
                        <p>No articles found in this category yet.</p>
                        <button
                            className="blog-filter-btn active"
                            onClick={() => setActiveCategory('All')}
                        >
                            View all articles
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BlogPage;
